<template>
  <div id="header">
    <p class="c3">
      <span style = 'overflow: hidden; display: inline-block; margin: 0.00px 0.00px; border: 0.00px solid #000000; transform: rotate(0.00rad) translateZ(0px); -webkit-transform: rotate(0.00rad) translateZ(0px); width: 100.00px; height: 100.00px;' >
        <img src='/images/brasao-governo-da-bahia.jpg' style='width: 100.00px; height: 100.00px; margin-left: 0.00px; margin-top: 0.00px; transform: rotate(0.00rad) translateZ(0px); -webkit-transform: rotate(0.00rad) translateZ(0px);' title=''>
      </span>
    </p> 
    <p class='c3'>
      <span class='c2'>Secretaria da Administra&ccedil;&atilde;o do Estado da Bahia &ndash; SAEB</span>
    </p>
    <p class='c3'>
      <span class='c2'>Habilita&ccedil;&atilde;o no Cadastro de Fornecedores do Estado da Bahia</span>
    </p>
  </div>
</template>

<script>


export default {
  name: "cabecalho-impressao",
  components: { /*Componentes utilizados*/
  },
  props: {//Propriedades que o objeto recebe como parametro

  },
  data() {//Declaracao de variaveis
    return {

    };
  },
  created() /*Metodo de start do componente*/{

  },
  methods: {//Declaracao de todos os metodos
  }
};
</script>

<style >
.c3{line-height:0.1;orphans:2;widows:2;text-align:center}
.c2{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:11pt;font-family:'Arial';font-style:normal}
</style>

